import { useCallback } from 'react';
import Head from 'next/head';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { buildTitle } from '../utils/layout';
import config from '../config';
import Main from '../components/main';
import { useAppContext } from '../contexts/app';
import MaterialLinkButton from '../components/material-link-button';

const useStyles = makeStyles(() => ({
  button: {
    whiteSpace: 'nowrap',
  },
}));

const Contact = () => {
  const classes = useStyles();
  const { login } = useAppContext();

  const handleLogin = useCallback((e) => {
    e.preventDefault();
    login();
  }, []);

  return (
    <Main>
      <Head>
        <title>{buildTitle('Features')}</title>
        <link rel="canonical" href={`${config().universal.baseUri}/features`} />
      </Head>

      <Typography variant="h1">Features</Typography>

      <ul>
        <li>Get get weekly emails about upcoming events</li>
        <li>Subscribe to the calendar in your calendar application of choice</li>
        <li>Join groups to get notified first about new events, communicate with group members, and share photos</li>
        <li>RSVP for events to get updates and communicate with other attendees</li>
        <li>Add your own events!</li>
      </ul>

      <p>Using Everyday Rides is completely free!</p>

      <MaterialLinkButton
        href="/login"
        variant="contained"
        color="primary"
        onClick={handleLogin}
        className={classes.button}
      >
        Sign Up
      </MaterialLinkButton>
    </Main>
  );
};

export default Contact;
